<template>
	<div class="myProfile">
		<van-nav-bar class="nav_bar" title="我的资料" left-arrow placeholder @click-left="onClickLeft" />
		<YjPersonal v-if="productName === 'weihua'" :fromPath="fromPath" />
		<YjGmPersonal v-else-if="productName === 'gongmao'" />
		<YjSlfhPersonal v-else-if="productName === 'slfh'" />
        <YjFMPersonal v-else-if="productName === 'feimei'" />
		<ysxUserInfo v-else-if="productName === 'ysx'"/> 
		<TrafficPersonal v-else-if="branchIndustry === 'traffic'"></TrafficPersonal>
		<Personal v-else></Personal>
	</div>
</template>

<script>
import Personal from './editProfile'
import TrafficPersonal from './editProfileNew'
import YjPersonal from '../../yingji/account/userInfo'
import YjSlfhPersonal from '../../yingji/account/slfhUserInfo'
import YjGmPersonal from '../../yingji/account/gmUserInfo'
import YjFMPersonal from '../../yingji/account/feimeiUserInfo'
import ysxUserInfo from '../../yingji/account/ysxUserInfo.vue'
export default {
	name: 'myProfile',
	data() {
		return {
            fromPath:'',
						productName:''
        }
	},
	components: { Personal, TrafficPersonal, YjPersonal, YjGmPersonal,YjFMPersonal,YjSlfhPersonal ,ysxUserInfo},
	computed: {
		/* 行业标签
            traffic  交通 meet_emergency应急
        */
		branchIndustry() {
			return this.$store.state.dynamic.pageSetData.branchIndustry
			// return 'traffic'
		},
	},
	beforeRouteEnter(to, from, next) {
		// /yj_m_register 党政干部注册
		next((vm) => {
			vm.fromPath = from.path
		})
	},
	created(){
		// 应急首页、登录定制化配置
    let devOptions = localStorage.getItem('devOptions')
    if (devOptions && devOptions.length) {
        devOptions = JSON.parse(devOptions)[0]
		this.productName = devOptions.sign
    }
	},
	mounted() {},
	methods: {
		onClickLeft() {
			this.$router.go(-1)
		},
	},
}
</script>

<style lang="stylus"></style>
